<template>
	<div class="list-wrap">
		<ol v-if="ordered">
			<li v-for="(item, index) in items"
				:key="index"
			    :draggable="`${draggable}`"
			    @dragstart="handleDragStart(index, $event)">
			    {{ item.text }}
			</li>
		</ol>

		<ul v-if="!ordered">
			<li v-for="(item, index) in items"
			    :key="index"
			    :draggable="`${draggable}`"
			    @dragstart="handleDragStart(index, $event)">
			    {{ item.text }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'ErcoListAtom',

	data() {
		return {};
	},

	props: {
		items: {
			type: Array,
			required: true,
		},

		ordered: {
			type: Boolean,
			default: false,
		},

		draggable: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleDragStart(index, e) {
			e.dataTransfer.effectAllowed = 'copy';
			e.dataTransfer.setData('text/plain', JSON.stringify(this.items[index]));
		},
	},
};
</script>

<style lang="scss">
	.list-wrap {
		& > ul,
		& > ol {
			padding: 0;

			& > li {
				border-bottom: 1px solid lightgray;
				padding: 0.3rem 0.1rem;

				&[draggable='true'] {
					cursor: move;
				}

				&:last-child {
					border: 0;
				}

				&:hover {
					background-color: rgba(242, 242, 242, 1);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoList.vue?748d0846